'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubtleListItem = exports.ListItem = exports.SubtleListItemStyle = exports.ListItemStyle = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n    padding: 1em;\n    display: flex;\n    align-items: center;\n    position: relative;\n    \n  \n    svg:first-of-type {\n        margin-right: .5em\n    }\n\n    &.with-icon-last svg:last-child {\n        margin-left: auto;\n        margin-right: 0;\n    }\n\n\n    cursor: ', ';\n    ', '\n'], ['\n    padding: 1em;\n    display: flex;\n    align-items: center;\n    position: relative;\n    \n  \n    svg:first-of-type {\n        margin-right: .5em\n    }\n\n    &.with-icon-last svg:last-child {\n        margin-left: auto;\n        margin-right: 0;\n    }\n\n\n    cursor: ', ';\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n        border: ', ';\n        border-radius: ', ';\n        margin: 0.5em 0;\n        background: ', ';\n        transition: box-shadow .2s ease;\n\n    \n        ', '\n\n    svg path {\n        fill: ', ';\n    }\n\n    \n'], ['\n        border: ', ';\n        border-radius: ', ';\n        margin: 0.5em 0;\n        background: ', ';\n        transition: box-shadow .2s ease;\n\n    \n        ', '\n\n    svg path {\n        fill: ', ';\n    }\n\n    \n']),
    _templateObject3 = _taggedTemplateLiteral(['\npadding: 1em;\nbackground: ', ';\nborder - bottom: 1px solid lightgrey;\n', '\n'], ['\npadding: 1em;\nbackground: ', ';\nborder - bottom: 1px solid lightgrey;\n', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _framerMotion = require('framer-motion');

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Li = (0, _styledComponents2.default)(_framerMotion.motion.li)(_templateObject, function (_ref) {
  var onClick = _ref.onClick;
  return onClick && 'pointer';
}, function (_ref2) {
  var theme = _ref2.theme,
      notification = _ref2.notification;
  return notification && notification.type !== '' && '\n            &::before {\n                content: \'\';\n                position: absolute;\n                top: 4px;\n                left: 4px;\n                height: 10px;\n                width: 10px;\n                border-radius: 50%;\n                background: ' + theme.stateColors[notification.type] + ';\n            }\n            &::after {\n                content: \'' + notification.text + '\';\n                background: ' + theme.stateColors[notification.type] + ';\n                border-radius: ' + theme.borderRadius + ';\n                position: absolute;\n                top: 0;\n                left: 10px;\n                overflow: visible;\n                padding: .5em;\n                opacity: 0;\n                transform: translate(0, -50%);\n                transition: .2s ease-out;\n                \n            }\n            &:hover::after{\n                transform: translate(0, -110%);\n                opacity: 1;\n                \n            }\n        ';
}); // box-shadow: ${({ theme }) => theme.shadow};

var ListItemStyle = exports.ListItemStyle = (0, _styledComponents2.default)(Li)(_templateObject2, function (_ref3) {
  var theme = _ref3.theme,
      isValidated = _ref3.isValidated;
  return '.1rem solid ' + (0, _chromaJs2.default)(theme.foreground).darken(0.3);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.foreground;
}, function (_ref6) {
  var type = _ref6.type,
      theme = _ref6.theme;
  return type === 'disabled' ? ' \n                    background: ' + theme.disabledForeground + ';\n                    box-shadow: none;\n                    pointer-events: none;\n                ' : '';
}, function (_ref7) {
  var theme = _ref7.theme,
      type = _ref7.type;
  return type === 'warning' ? theme.stateColors.warning : '';
});
var SubtleListItemStyle = exports.SubtleListItemStyle = (0, _styledComponents2.default)(Li)(_templateObject3, function (_ref8) {
  var theme = _ref8.theme;
  return theme.middleground;
}, function (_ref9) {
  var active = _ref9.active,
      theme = _ref9.theme;
  return active === true && '\n            font-weight: 500;\n            color: ' + theme.brandColor + ';\n        ';
});

var ListItem = exports.ListItem = function ListItem(props) {
  var listEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (listEl.current.lastChild.tagName === 'svg') {
      listEl.current.classList.add('with-icon-last');
    }
  }, []);
  return _react2.default.createElement(ListItemStyle, _extends({
    className: 'ListItem',
    ref: listEl
  }, props), props.children);
};

var SubtleListItem = exports.SubtleListItem = function SubtleListItem(props) {
  var listEl = (0, _react.useRef)(null);
  var active = props.active || false;
  (0, _react.useEffect)(function () {
    if (listEl.current.lastChild.tagName === 'svg') {
      listEl.current.classList.add('with-icon-last');
    }
  });
  return _react2.default.createElement(SubtleListItemStyle, _extends({
    className: 'SubtleListItem',
    ref: listEl
  }, props, {
    active: active
  }), props.children);
};